import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function About() {
  const { t } = useTranslation();
  useEffect(() => {
    // Initialize Swiper when the component mounts
    if (window.Swiper) {
        console.log("Swiper is loaded on the page.");
    const swiperReviews = new window.Swiper(".reviews__swiper", {
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: "bullets"
        },
        breakpoints: {
            320: {
                direction: "horizontal",
                slidesPerView: 1.2,
                spaceBetween: 40
            },
            640: {
                direction: "horizontal",
                slidesPerView: 2.2,
                spaceBetween: 40
            },
            1000: {
                direction: "vertical",
                slidesPerView: "auto",
                freeMode: true,
                mousewheel: true,
                spaceBetween: 32,
                centeredSlides: true
            }
        }
    });
    } else {
        console.error("Swiper is not loaded on the page.");
    }
}, []); // Empty dependency array ensures this runs only once

  return (
    <main className="main">
    <section className="hero">
      <div className="hero__container container">
        <div className="hero__inner">
          <h1 className="hero__title">
            <span className="one-stop-solution">{t('One-Stop Solution to')}</span>
            <span className="studying">{t('Studying')}</span>
            <span className="in-your">{t('in your')}</span>
            <span className="dream-university">{t('Dream University')}</span>
          </h1>
          <ul className="hero__advantages">
            <li>{t('Find a Study Program abroad')}</li>
            <li>{t('Complete your')} <b>{t('Student Visa')}</b> {t('application')}</li>
            <li>{t('Get help with housing')}</li>
          </ul>
          <form className="hero__study hero-study">
            <h2 className="hero-study__title">{t('Book Study Abroad Program')}</h2>
            <div className="custom-select">
              <button className="select-button" type="button">{t('Where do you want to study')}</button>
              <ul className="select-dropdown">
                <li><label><span>{t('Fort Lauderdale')}</span><input type="radio" name="where-study" value="Fort Lauderdale" /></label></li>
                <li><label><span>{t('Boston')}</span><input type="radio" name="where-study" value="Boston" /></label></li>
                <li><label><span>{t('San Francisco')}</span><input type="radio" name="where-study" value="San Francisco" /></label></li>
              </ul>
            </div>
            <div className="custom-select">
              <button className="select-button" type="button">{t('How long do you want to study?')}</button>
              <ul className="select-dropdown">
                <li><label><span>{t('Not sure yet')}</span><input type="radio" name="how-long" value="Not sure yet" /></label></li>
                <li><label><span>{t('3 months')}</span><input type="radio" name="how-long" value="3 months" /></label></li>
                <li><label><span>{t('6 months')}</span><input type="radio" name="how-long" value="6 months" /></label></li>
                <li><label><span>{t('1 year')}</span><input type="radio" name="how-long" value="1 year" /></label></li>
                <li><label><span>{t('2 years (Associate\'s degree)')}</span><input type="radio" name="how-long" value="2 years" /></label></li>
                <li><label><span>{t('4 years (Bachelor\'s degree)')}</span><input type="radio" name="how-long" value="4 years" /></label></li>
                <li><label><span>{t('6 years (Master\'s degree)')}</span><input type="radio" name="how-long" value="6 years" /></label></li>
                <li><label><span>{t('8+ years (PhD)')}</span><input type="radio" name="how-long" value="8+ years" /></label></li>
              </ul>
            </div>
          </form>
          <button
            className="button button--primary hero-study__button"
            onClick={() => {
              document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
              setTimeout(() => { document.getElementById('email').focus(); }, 1500);
            }}
          >
            {t('Continuing Education? Click Here')}
          </button>
        </div>
        <picture className="hero__img">
          <source srcSet="./assets/img/cover.jpg" media="(max-width: 767px)" />
          <img src="./assets/img/cover.jpg" alt={t('Cover Image')} />
        </picture>
      </div>
    </section>
  
    {/* Why Us Section */}
    <section className="why-us">
      <div className="why-us__container container">
        <div className="why-us__content">
          <h2 className="title-section why-us__title">{t('Why choose us')}</h2>
          <ul className="why-us__list">
            <li className="why-us__item">
              <img className="why-us__item-icon" src="./assets/img/why-us/01.svg" alt={t('Icon 1')} />
              <span className="why-us__item-title">{t('Minimum Paperwork')}</span>
            </li>
            <li className="why-us__item">
              <img className="why-us__item-icon" src="./assets/img/why-us/02.svg" alt={t('Icon 2')} />
              <span className="why-us__item-title">{t('Extensive school choice')}</span>
            </li>
            <li className="why-us__item">
              <img className="why-us__item-icon" src="./assets/img/why-us/03.svg" alt={t('Icon 3')} />
              <span className="why-us__item-title">{t('Transparent Fees')}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  
    {/* With Us Section */}
    <section className="with-us">
      <div className="with-us__container container">
        <div className="with-us__content">
          <h2 className="title-section">{t('With Boundless 101')}</h2>
          <ul className="with-us__list">
            <li className="with-us__item">{t('You improve your English')}</li>
            <li className="with-us__item">{t('You get matched with universities')}</li>
            <li className="with-us__item">{t('You book online')}</li>
            <li className="with-us__item with-us__item--hidden"></li>
            <li className="with-us__item">{t('You receive full visa support')}</li>
            <li className="with-us__item">{t('You get a customized adaptation plan')}</li>
            <li className="with-us__item">{t('You will connect with student ambassadors')}</li>
            <li className="with-us__item">{t('You move abroad to study')}</li>
          </ul>
        </div>
      </div>
    </section>
  
    {/* Helps Section */}
    <section className="helps">
      <div className="helps__container container">
        <h2 className="title-section">{t('How Boundless 101 helps you')}</h2>
        <ul className="helps__items">
          <li className="helps__item helps-item">
            <div className="helps-item__img">
              <span className="helps-item__num">1</span>
              <img src="./assets/img/helps/01.jpg" alt={t('Help Image 1')} />
            </div>
            <p className="helps-item__text">{t('You can start with learning English from the comfort of your home')}</p>
          </li>
          <li className="helps__item helps-item">
            <div className="helps-item__img">
              <span className="helps-item__num">2</span>
              <img src="./assets/img/helps/02.jpg" alt={t('Help Image 2')} />
            </div>
            <p className="helps-item__text">{t('Then effortlessly find your ideal school, college, or university anywhere in the world')}</p>
          </li>
          <li className="helps__item helps-item">
            <div className="helps-item__img">
              <span className="helps-item__num">3</span>
              <img src="./assets/img/helps/03.jpg" alt={t('Help Image 3')} />
            </div>
            <p className="helps-item__text">{t('Let Boundless101 coordinate and streamline your visa process')}</p>
          </li>
          <li className="helps__item helps-item">
            <div className="helps-item__img">
              <span className="helps-item__num">4</span>
              <img src="./assets/img/helps/04.jpg" alt={t('Help Image 4')} />
            </div>
            <p className="helps-item__text">{t('Receive a personalized plan for a smooth transition, covering cultural adaptation, financial guidance, and settling into your chosen country')}</p>
          </li>
        </ul>
        <button
          className="button button--primary helps__button"
          onClick={() => {
            document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => { document.getElementById('email').focus(); }, 1500);
          }}
        >
          {t('Let’s Start')}
        </button>
        </div>
  </section>

  {/* About Section */}
  <section className="about">
    <div className="about__container container">
      <h2 className="title-section">{t('Who we are')}</h2>
      <div className="about__text">
        <p>{t('Boundless101 is a one-stop platform for international students to learn English, connect with educational institutions abroad, and get customized adaptation plans for their new country.')}</p>
        <p>{t('Rooted in founder Karyna Kazhamiakina\'s transformative educational journey from Belarus to the U.S., Boundless101 is committed to bridging educational divides, offering students pathways to global opportunities, cultural immersion, and personal development.')}</p>
        <p>{t('Our mission is a world where education knows no borders, enabling students to seamlessly transition into new educational and cultural environments with the support of advanced technology and a profound understanding of their unique needs.')}</p>
      </div>
    </div>
  </section>

  {/* Institutions Section */}
  <section className="institutions">
    <div className="institutions__container container">
      <h2 className="title-section">{t('Top educational institutions to study in')}</h2>
      <div className="institutions__list swiper">
        <div className="institutions__swiper swiper-wrapper">
          <article className="institutions__card institutions-card swiper-slide">
            <img className="institutions-card__logo" src="./assets/img/institutions/kaplan.svg" alt={t('Kaplan')} />
            <p className="institutions-card__text">{t('Study English in the US, Canada, England, or Europe with one of the leading language schools in the world. Variety of schools in the US: choice from Los Angeles, Santa Barbara, and San Francisco in California; New York; Chicago, Illinois; and Seattle, Washington. Classes start every week. Student accommodation is available in either student residences or homestays.')}</p>
            <a className="institutions-card__button button button--outline" onClick={() => {
              document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
              setTimeout(() => { document.getElementById('email').focus(); }, 1500);
            }}>{t('Learn More')}</a>
          </article>
          <article className="institutions__card institutions-card swiper-slide">
            <img className="institutions-card__logo" src="./assets/img/institutions/Talk.svg" alt={t('Talk')} />
            <p className="institutions-card__text">{t('Language school in the US with English, professional development, and company experience programs in business, finance, psychology, marketing, and management. As well as summer programs for the whole family. Study in San Francisco, California; Boston, Massachusetts; Atlanta, Georgia; Miami, Aventura, and Fort Lauderdale in Florida.')}</p>
            <a className="institutions-card__button button button--outline" onClick={() => {
              document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
              setTimeout(() => { document.getElementById('email').focus(); }, 1500);
            }}>{t('Learn More')}</a>
          </article>
          <article className="institutions__card institutions-card swiper-slide">
            <img className="institutions-card__logo" src="./assets/img/institutions/CSI.svg" alt={t('CSI')} />
            <p className="institutions-card__text">{t('Annual business, healthcare, and IT programs in Chicago, Illinois, and Boston, Massachusetts with CPT and OPT opportunities for international students. Pursue a career-oriented education for one year, regardless of your prior experience in the field. Upon completion, you\'ll have the opportunity to work for an American company, with internship programs available to enhance your professional development.')}</p>
            <a className="institutions-card__button button button--outline" onClick={() => {
              document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
              setTimeout(() => { document.getElementById('email').focus(); }, 1500);
            }}>{t('Learn More')}</a>
          </article>
        </div>
      </div>
    </div>
  </section>

  {/* Map Section */}
  <section className="map">
    <div className="map__container">
      <h2 className="title-section container">{t('What is your dream country to study and live in?')}</h2>
      <div className="map__wrapper">
        <img className="map__img" src="./assets/img/map/map-net.svg" alt={t('Map')} />
        <a className="map__flag map__flag--canada" href="##">
          <img src="./assets/img/map/canada.svg" alt={t('Canada')} />
        </a>
        <a className="map__flag map__flag--usa" onClick={() => {
          document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
          setTimeout(() => { document.getElementById('email').focus(); }, 1500);
        }}>
          <img src="./assets/img/map/usa.svg" alt={t('USA')} />
        </a>
        <a className="map__flag map__flag--brazil" onClick={() => {
          document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
          setTimeout(() => { document.getElementById('email').focus(); }, 1500);
        }}>
          <img src="./assets/img/map/brazil.svg" alt={t('Brazil')} />
        </a>
        <a className="map__flag map__flag--france" onClick={() => {
          document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
          setTimeout(() => { document.getElementById('email').focus(); }, 1500);
        }}>
          <img src="./assets/img/map/france.svg" alt={t('France')} />
        </a>
        <a className="map__flag map__flag--germany" onClick={() => {
          document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
          setTimeout(() => { document.getElementById('email').focus(); }, 1500);
        }}>
          <img src="./assets/img/map/germany.svg" alt={t('Germany')} />
        </a>
        <a className="map__flag map__flag--australia" onClick={() => {
          document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
          setTimeout(() => { document.getElementById('email').focus(); }, 1500);
        }}>
          <img src="./assets/img/map/australia.svg" alt={t('Australia')} />
        </a>
      </div>
    </div>
  </section>

  {/* Support Section */}
  <section className="support">
    <div className="support__container container">
      <h2 className="title-section support__title">{t('Free Consultation and Support with Student Ambassador')}</h2>
      <div className="support__content">
        <article className="support__card support-card">
          <h3 className="support-card__title">{t('Get a FREE consultation')}</h3>
          <span className="support-card__price">$50 {t('value!')}</span>
          <span className="support-card__plan">{t('Full service help and guidance')}</span>
          <button className="button button--secondary support-card__button" onClick={() => {
            document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => { document.getElementById('email').focus(); }, 1000);
          }}>{t('Book Now')}</button>
        </article>
        <ul className="support__advantages">
          <li className="support__advantages-item">{t('Have questions about travel, study, or cultural adaptation? Get answers anytime.')}</li>
          <li className="support__advantages-item">{t('Connect with student ambassadors who can offer personalized insights and support. Schedule calls to get in-depth guidance tailored to your needs.')}</li>
          <li className="support__advantages-item">{t('Request comprehensive adaptation plans to help you navigate your new environment smoothly.')}</li>
        </ul>
      </div>
    </div>
  </section>

  {/* Contact Us Section */}
  <section className="contact-us" id="contact-us">
    <div className="contact-us__container container">
      <div className="contact-us__body">
        <h2 className="title-section">{t('Looking for guidance? Our team is ready to assist!')}</h2>
        <p className="contact-us__text">
          {t('Enter your email for a free consultation with one of our study-abroad specialists.')}<br />
          {t('They\'ll provide expert advice on selecting the right country, university, and degree for you.')}
        </p>
        <form className="contact-us__form">
          <div className="custom-select">
            <button className="select-button" id="subject" type="button">{t('Select Subject')}</button>
            <ul className="select-dropdown">
              <li><label><span>{t('Study Abroad Program')}</span><input type="radio" name="where-study" value="Study Abroad Program" /></label></li>
              <li><label><span>{t('Learn English with AI')}</span><input type="radio" name="where-study" value="Learn English with AI" /></label></li>
              <li><label><span>{t('Other')}</span><input type="radio" name="where-study" value="Other" /></label></li>
            </ul>
          </div>
          <p><br /></p>
          <input type="email" id="email" name="email" placeholder={t('ENTER YOUR EMAIL')} className="input-field" required />
          <p><br /></p>
          <button id="submit-button" className="button button--primary" type="submit">{t('Submit')}</button>
        </form>
      </div>
    </div>
  </section>
</main>

  
  );
}

export default About;
